import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className='container mx-auto px-4 py-8 max-w-4xl'>
      <div className='text-center mb-8'>
        <h2 className='text-3xl font-bold text-foreground mb-2'>
          Landcar Agency, Inc. dba Total Care Auto Powered by Landcar
        </h2>
        <h2 className='text-2xl font-semibold text-foreground mb-2'>
          TERMS OF USE
        </h2>
        <h3 className='text-xl font-medium text-foreground'>
          LENDER REFUND QUOTE PORTAL ACCESS
        </h3>
      </div>

      <div className='prose prose-lg max-w-none space-y-6'>
        <section>
          <p className='text-muted-foreground leading-relaxed'>
            These Terms of Use shall govern the access and use of the Lender
            Refund Quote Portal and related functions and services (the
            &ldquo;Portal&rdquo;) offered by Landcar Agency, Inc. dba Total Care
            Auto Powered by Landcar (&ldquo;TCA&rdquo;), a Utah corporation,
            with principal offices at 351 W. Opportunity Way, Suite 440, Draper,
            UT 84020 and your company (&ldquo;You&rdquo;), including Your
            affiliates, employees and Designated Subcontractors (as hereinafter
            defined).
          </p>
        </section>

        <section>
          <p className='text-muted-foreground leading-relaxed'>
            These Terms of Use are intended to constitute a binding agreement
            that governs Your use of the Portal. By accessing or using the
            Portal, its website and related software, tools, files and
            information, You agree that You have read, acknowledge and assent to
            be bound by all of the terms, conditions and notices contained in
            these Terms of Use. By accessing and using the Portal, You express
            your understanding and agreement that You are bound by these Terms
            of Use. If You are unwilling to be bound by these general terms and
            conditions with respect to any Portal, do not access or use the
            Portal. TCA reserves the right to change these Terms of Use at any
            time in keeping with its purpose, and Your continued use of this
            website constitutes your agreement to all such terms, conditions and
            notices.
          </p>
        </section>

        <section>
          <p className='text-muted-foreground leading-relaxed'>
            You have requested access be granted to Lender employees and/or
            subcontractors approved in advance by TCA (&ldquo;Assigned
            Employees&rdquo; or &ldquo;Designated Subcontractors,&rdquo; who are
            collectively &ldquo;Users&rdquo;) for use of the Portal. By doing
            so, TCA will provide such Users limited access to TCA systems,
            software and Confidential Information.
          </p>
        </section>

        <section>
          <p className='text-muted-foreground leading-relaxed'>
            Unauthorized use of the website and TCA&apos;s systems for the
            Portal, including, but not limited to, unauthorized entry into TCA
            systems, misuse of passwords or misuse of any other information, is
            strictly prohibited. You may not use the website in any manner that
            could damage, disable, overburden, or impair the website or service
            or interfere with any other party&apos;s use and enjoyment of the
            website or service. You may not attempt to gain unauthorized access
            to the website or service, computer systems or networks connected to
            the website or service, through hacking, password mining or any
            other means. You may not use any system or software to extract data
            from the website.
          </p>
        </section>

        <section>
          <p className='text-muted-foreground leading-relaxed'>
            TCA reserves the right, in its sole discretion, without any
            obligation and without any notice requirement and for any reason, to
            change, improve or correct the information and materials on this
            website and to suspend and/or deny access to this website or
            portions thereof for scheduled or unscheduled maintenance, upgrades,
            improvements, corrections or otherwise. Any dated information is
            published as of its date only, and TCA does not undertake any
            obligation or responsibility to update or amend any such
            information. TCA may discontinue or change any product, service,
            information or material described in or offered on this website at
            any time.
          </p>
        </section>

        <section>
          <p className='text-muted-foreground leading-relaxed mb-4'>
            By accepting these Terms of Use, You agree to the following terms
            and conditions:
          </p>

          <div className='space-y-6'>
            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                1. Limited Access and Use.
              </h3>
              <p className='text-muted-foreground leading-relaxed'>
                TCA grants You, for Yourself, Your Assigned Employees, and Your
                Designated Subcontractors only, the right to access and use the
                Portal, subject to and in accordance with these Terms of Use.
              </p>
            </div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                2. Permitted Use.
              </h3>
              <div className='space-y-4'>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2'>
                    2.1
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    The Portal is provided in connection with other definitive
                    agreements with third parties for Lender services and
                    transaction support provided by You and TCA respectively, to
                    such third parties, which will govern those services and
                    transactions.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2'>
                    2.2
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    The Refund Quote for cancellation provided through the
                    Portal is an estimated amount based on information available
                    on the date of request and other assumptions made by TCA.
                    Final refund amounts are subject to change and will be
                    determined at the time of actual cancellation processing, in
                    accordance with the terms and conditions of the applicable
                    and underlying contract. Factors such as the effective
                    cancellation date, prior claims, miles driven, and
                    cancellation fees may affect the final amount. TCA
                    accordingly does not warrant that the estimate is accurate
                    or final, and TCA shall have no liability for errors or
                    omissions alleged to arise with respect to any Refund Quote,
                    its processing or potential use.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2'>
                    2.3
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You will limit access to (and disclosure and use of) the
                    Portal and such TCA Confidential Information to which you
                    are given access to the minimum necessary in order to
                    conduct and process the services and transactions You
                    provide to your customers.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                3. Access Only by Employees and Designated Subcontractors with
                Need.
              </h3>
              <div className='space-y-4'>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    3.1 Assigned Employees.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    Except as provided in subsection 3.2 below with respect to
                    Designated Subcontractors (or as otherwise agreed by TCA in
                    writing), You will limit Your access to TCA Confidential
                    Information only to those of Your direct employees who must
                    have that access in order to provide Your services and
                    transaction support.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    3.2 Designated Subcontractors.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You may provide access to the Portal and TCA Confidential
                    Information to a third party acting in the capacity as a
                    Designated Subcontractor only to the extent that (i) the
                    Designated Subcontractor reasonably requires such access to
                    the Portal and TCA Confidential Information in order to
                    provide or support Your services, and (ii) You shall require
                    any such Designated Subcontractor to comply with these Terms
                    of Use. You are responsible for each Designated
                    Subcontractor&apos;s compliance with these Terms of Use.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    3.3 Registration Requirements and User Credentials.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You agree to register each such employee and each Designated
                    Subcontractor who You agree to authorize to access and use
                    the Portal through{' '}
                    <a
                      href='mailto:helpdesk@asburyauto.com'
                      className='text-accent'
                    >
                      helpdesk@asburyauto.com
                    </a>
                    . Through such registration, the employee and/or Designated
                    Subcontractor will be assigned a unique user ID and password
                    (&ldquo;User Credentials&rdquo;) to access the Portal. You
                    further agree to notify TCA promptly through{' '}
                    <a
                      href='mailto:helpdesk@asburyauto.com'
                      className='text-accent'
                    >
                      helpdesk@asburyauto.com
                    </a>
                    &nbsp; whenever any authorized employee or Designated
                    Subcontractor no longer requires access to the Portal or
                    otherwise ceases to be authorized to engage in functions
                    requiring such access. Neither You nor any such employee or
                    Designated Subcontractor will not share or otherwise
                    disseminate or permit disclosure of any information
                    regarding User Credentials. You will immediately notify TCA
                    if You become aware that any User Credentials have been
                    compromised (e.g., through presence of a key logger or
                    through sharing of a password) and fully cooperate with TCA
                    to investigate any such event.
                  </p>
                </div>
              </div>
            </div>

            <div></div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                4. Confidentiality and Security.
              </h3>
              <div className='space-y-4'>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    4.1 Confidentiality.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You understand and agree that TCA Confidential Information
                    contains confidential and trade secret information of TCA
                    protected by operation of law and these Terms of Use. You
                    will maintain in confidence all TCA Confidential Information
                    in accordance with these Terms of Use and applicable data
                    protection laws.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    4.2 Security and Privacy Obligations.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You agree to use, and You agree to require each employee and
                    each Designated Subcontractor who You agree to authorize to
                    access and use the Portal, appropriate safeguards to
                    maintain the security of the TCA Confidential Information
                    and the services and transaction support provided by TCA.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    4.3 Prohibited Uses.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You will use, and You will permit each employee and each
                    Designated Subcontractor who You agree to authorize to
                    access and use the Portal and related systems, software and
                    TCA Confidential Information, only as necessary to provide
                    Your services to Your customers and not for any other
                    purpose, including but not limited to any marketing-related
                    purpose.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                5. Termination.
              </h3>
              <p className='text-muted-foreground leading-relaxed'>
                Either party may terminate these Terms of Use or use of the
                Portal, as a whole or in any more limited respect, at any time
                upon written notice to the other party.
              </p>
            </div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                6. Limitation of Liability.
              </h3>
              <p className='text-muted-foreground leading-relaxed'>
                TCA, FOR ITSELF AND ITS AFFILIATES, ASSUMES NO LIABILITY FOR
                LOSS OR DAMAGE RESULTING FROM ANY USE OF OR RELIANCE UPON THE
                PORTAL OR THE INFORMATION PROVIDED THEREIN. IN NO EVENT WILL TCA
                OR ANY OF ITS AFFILIATES BE LIABLE FOR ANY LOST PROFITS, LOST
                SAVINGS, LOST DATA, BUSINESS INTERRUPTION, OR OTHER DIRECT,
                INDIRECT, EXEMPLARY, PUNITIVE, SPECIAL, CONSEQUENTIAL OR
                INCIDENTAL DAMAGES OR CLAIMS (WHETHER IN CONTRACT, IN TORT, OR
                OTHERWISE) ARISING OUT OF OR RELATING TO YOUR OR YOUR
                EMPLOYEES&apos; OR DESIGNATED CONTRACTORS&apos; USE OF THE
                PORTAL OR INFORMATION PROVIDED THEREIN, OR THE INABILITY TO USE
                THE SAME, EVEN IF YOU CLAIM TO HAVE NOTIFIED TCA OF THE
                POSSIBILITY OF SUCH LOSS OR DAMAGE.
              </p>
            </div>

            <div>
              <h3 className='text-xl font-bold text-foreground mb-3'>
                7. Miscellaneous.
              </h3>
              <div className='space-y-4'>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.1 Compliance Reviews.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    Upon reasonable notice and during normal business hours, no
                    more frequently than quarterly, you agree to cooperate with
                    TCA to verify Your and Your employees&apos; and Designated
                    Subcontractors&apos; compliance with these Terms of Use. You
                    agree to provide such information and records as may be
                    reasonable requested in order to establish such compliance.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.2 No Assignment.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    You will not assign, transfer, sublicense, or delegate any
                    of Your rights or obligations under these Terms of Use,
                    except with the express written consent of TCA. These Terms
                    of Use will terminate immediately in the event of any
                    assignment, transfer, sublicense, or delegation in violation
                    of this subsection.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.3 No Waiver.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    The provisions of these Terms of Use will be severable, so
                    that the invalidity or unenforceability of any provisions
                    will not affect the validity or enforceability of the
                    remaining provisions and any invalid or unenforceable
                    provisions will be enforced to the maximum extent possible.
                    The failure of a party to require the performance of any
                    obligation will not be considered a waiver or modification
                    of the terms of these Terms of Use, and if a party agrees to
                    waive a breach or lapse in any instance, it will not be
                    considered a waiver in any other instances. Except as
                    expressly provided in these Terms of Use, You and your
                    employees and Designated Subcontractors acquire no rights in
                    TCA Confidential Information, whether express, implied or by
                    estoppel.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.4 Entire Agreement.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    These Terms of Use, along with any other definitive
                    agreement between TCA and You regarding the services and
                    transaction processing provided by TCA to You and Your
                    organization, is the entire agreement with regard to its
                    subject matter and may not be amended except by written
                    agreement.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.5 Governing Law.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    These Terms of Use is governed by the laws of the State of
                    Delaware, without reference to its conflicts of law
                    principles.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.6 Construction.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    Headings contained in these Terms of Use are for reference
                    purposes only and will not affect in any way the meaning and
                    interpretation of these Terms of Use. As used in the
                    Agreement, the word &ldquo;include&rdquo; and all variants
                    (e.g., &ldquo;included&rdquo;, &ldquo;includes,&rdquo;
                    &ldquo;including&rdquo;) are not words of limitation;
                    similarly, each example in the Agreement is provided only
                    for the purpose of illustration and should not be construed
                    as a limitation.
                  </p>
                </div>
                <div>
                  <h4 className='text-lg font-bold text-foreground mb-2 underline'>
                    7.7 Authorized Representatives.
                  </h4>
                  <p className='text-muted-foreground leading-relaxed'>
                    Each party represents that the individual signing below on
                    behalf of the party has the authorization to bind the party
                    indicated to these Terms of Use. These Terms of Use and its
                    incorporated documents may be signed on paper, by facsimile,
                    or electronically, and may also be signed in counterparts.
                    Signatures sent by facsimile, PDF, or otherwise provided
                    electronically will be deemed originals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
